export default __webpack_public_path__ + "static/tree-photo-fb52c188ee3e33828a37601414c7cb68.jpg";